<template>
    <div
        v-if="publishedDate"
        class="post-details mt-7"
    >
        <h2
            v-if="title"
            class="typo-h4 post-details__title mt-0"
        >
            {{ title }}
        </h2>
        <div class="d-flex justify-content-start post-details__contents">
            <div class="d-flex justify-content-start align-items-center ml-3 post-details__date">
                <y-icon
                    icon="calendar"
                    prefix="far"
                    color="black"
                    size="small"
                    class="ml-1"
                />
                <span class="typo-body-2">
                    {{ date(publishedDate, 'YYYY/MM/DD', $i18n.locale) }}
                </span>
            </div>
            <div class="d-flex justify-content-start align-items-center ml-3">
                <y-icon
                    icon="clock"
                    prefix="far"
                    color="black"
                    size="small"
                    class="ml-1"
                />
                <span class="typo-body-2">{{ $t('blog.read_text') }}</span>
            </div>
        </div>
        <p
            v-if="synopsis"
            class="typo-body-1 post-details__synopsis mb-10 mt-7"
        >
            {{ synopsis }}
        </p>
    </div>
</template>

<script>
    import { YIcon } from '@components/index';
    import { date } from '@nodes/helpers/date';

    export default {
        name: 'Details',
        
        components: {
            YIcon,
        },
        
        props: {
            /**
             * post published date
             */
            publishedDate: [Number, String],

            /**
             * post title
             */
            title: String,
            
            /**
             * post synopsis
             */
            synopsis: String,
        },

        methods: {
            date,
        },
    };
</script>

<style lang="scss" src="./index.scss" />
